import React, { useContext, useState } from 'react'
import { AppContext } from '../context/AppContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CONFIG } from '../config/general';
import { toast } from 'react-toastify';
import { updateAdminPassword } from '../services/adminServices';

const Header = () => {
  const { login, setLogin } = useContext(AppContext);
  const [passwordModal, setPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation()

  const handleLogout = () => {
    setLogin({ ...login, isLogin: false, token: null });
    localStorage.removeItem("token")
    localStorage.removeItem("userRole")
    navigate('/login');
  };

  const handleChangePassword = async () => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!currentPassword) {
      setError("Current password must be there.");
      return;
    }
    if (!regex.test(newPassword)) {
      setError("Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.");
      return;
    }
    if (currentPassword == newPassword) {
      setError("Current password and new password must not be same.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      let result = await updateAdminPassword(login.token, { newPassword: newPassword, confirmPassword: confirmPassword, currPassword: currentPassword })
      if (result.success) {
        toast.success(result.message)
        setNewPassword("")
        setCurrentPassword("")
        setConfirmPassword("")
        setPasswordModal(false)
      } else {
        toast.error(result.message)
      }
    } catch (error) {
      console.error("Error changing password:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const findPage = () => {
    if (location.pathname === "/dashboard" || location.pathname === "/adminDashboard") {
      document.title = "Home | Prabhu Chat"
      return "Home"
    }
    if (location.pathname === "/companies" || location.pathname.includes("/details")) {
      document.title = "Companies | Prabhu Chat"
      return "Companies"
    }
    if (location.pathname === "/login") {
      document.title = "Login | Prabhu Chat"
      return "Login"
    }
    if (location.pathname === "/requestedKeys" || location.pathname === "/keysRequest") {
      document.title = "Keys | Prabhu Chat"
      return "Keys"
    }
    if (location.pathname === "/settings" || location.pathname === "/adminSettings") {
      document.title = "Settings | Prabhu Chat"
      return "Settings"
    }
    if (location.pathname === "/advertisement") {
      document.title = "Advertisement | Prabhu Chat"
      return "Advertisement"
    }
    if (location.pathname === "/versions") {
      document.title = "Version Manager | Prabhu Chat"
      return "Version Manager"
    }
  }

  return (
    <>
      <header>
        <div className="siteHeader d_flex flex-wrap">
          <div className="headerWrap">
            <nav style={{ "--bs-breadcrumb-divider": "'>';" }} aria-label="breadcrumb">
              <ol className="breadcrumb m-0 ms-lg-4">
                <li className="breadcrumb-item fs-18"><a href="#">Admin</a></li>
                <li className="breadcrumb-item active fs-18" aria-current="page">{findPage()}</li>
              </ol>
            </nav>
          </div>
          {login.isLogin ? <div className="headerWrap">
            <a className="notification main-tooltip" href="#">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="18" r="18" fill="#EBEFFF" />
                <path d="M24.1167 20.0751L23.2833 18.6917C23.1083 18.3834 22.95 17.8001 22.95 17.4584V15.3501C22.95 13.3917 21.8 11.7001 20.1417 10.9084C19.7083 10.1417 18.9083 9.66675 17.9917 9.66675C17.0833 9.66675 16.2667 10.1584 15.8333 10.9334C14.2083 11.7417 13.0833 13.4167 13.0833 15.3501V17.4584C13.0833 17.8001 12.925 18.3834 12.75 18.6834L11.9083 20.0751C11.575 20.6334 11.5 21.2501 11.7083 21.8167C11.9083 22.3751 12.3833 22.8084 13 23.0167C14.6167 23.5667 16.3167 23.8334 18.0167 23.8334C19.7167 23.8334 21.4167 23.5667 23.0333 23.0251C23.6167 22.8334 24.0667 22.3917 24.2833 21.8167C24.5 21.2417 24.4417 20.6084 24.1167 20.0751Z" fill="#1edd60" />
                <path d="M20.3584 24.6751C20.0084 25.6417 19.0834 26.3334 18 26.3334C17.3417 26.3334 16.6917 26.0667 16.2334 25.5917C15.9667 25.3417 15.7667 25.0084 15.65 24.6667C15.7584 24.6834 15.8667 24.6917 15.9834 24.7084C16.175 24.7334 16.375 24.7584 16.575 24.7751C17.05 24.8167 17.5334 24.8417 18.0167 24.8417C18.4917 24.8417 18.9667 24.8167 19.4334 24.7751C19.6084 24.7584 19.7834 24.7501 19.95 24.7251C20.0834 24.7084 20.2167 24.6917 20.3584 24.6751Z" fill="#1edd60" />
                <circle cx="31" cy="5" r="4" fill="#FA3E3E" />
              </svg>
              <span className="tooltip">Coming Soon</span>
            </a>
            <div className="userName d-flex flex-wrap">
              <img src={CONFIG.REACT_APP_UPLOADS + "/" + (login?.user?.profilePicture ? login.user.profilePicture : "profilepicture.png")} alt="user" style={{ height: "50px", borderRadius: "50%" }} />
              <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle fs-18" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {login?.user?.name}
                </button>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/dashboard">Dashboard</Link></li>
                  {login.userRole ? <li><Link className="dropdown-item" onClick={() => setPasswordModal(true)}>Change Password</Link></li>:""}
                  <li><a className="dropdown-item" onClick={handleLogout} style={{cursor:"pointer"}}>Logout</a></li>
                </ul>
              </div>
            </div>
          </div> : <>
            <div><a className="dropdown-item" href="#/login">Login</a></div>
          </>}
        </div>
        {passwordModal && <div
          className="modal d-block show"
          id="changePasswordModal"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="changePasswordModalLabel">
                  Change Password
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setPasswordModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="currentPassword" className="form-label">
                    Current Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="currentPassword"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                {error && <p className="text-danger">{error}</p>}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setPasswordModal(false)}
                  id="closeChangePasswordModal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ backgroundColor: '#1edd60', border: "none", color: "#fff" }}
                  onClick={handleChangePassword}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>}
      </header>
    </>
  )
}

export default Header
